<template>
    <div>
        <alert-modal :modalId="alertId"
                     :controller="controller.alertModal"
                     v-if="controller.alertModal != null"
        ></alert-modal>
        <confirm-modal
                    :modalId="confirmId"
                    :controller="controller.confirmModal"
                    v-if="controller.confirmModal != null"
        ></confirm-modal>
        <error-modal :modalId="errorId"
                    :controller="controller.errorModal"
                    v-if="controller.errorModal != null"
        ></error-modal>
        <loading-modal
                    :modalId="loadingId"
                    :controller="controller.loadingModal"
                    v-if="controller.loadingModal != null"
        ></loading-modal>
        <no-internet-modal
                    :modalId="noInternetId"
                    :controller="controller.noInternetModal"
                    v-if="controller.noInternetModal != null">
        </no-internet-modal>
        <success-modal
                    :modalId="successId"
                    :controller="controller.successModal"
                    v-if="controller.successModal != null"
        ></success-modal>
        <terms-modal
                    :modalId="termsId"
                    :controller="controller.termsModal"
                    v-if="controller.termsModal != null"
        ></terms-modal>
        <copy-success-toast
                    :controller="controller.copySuccessToast"
                    v-if="controller.copySuccessToast != null"
        ></copy-success-toast>
        <confirm-redeem-modal
                    :modalId="confirmRedeemId"
                    :controller="controller.confirmRedeemModal"
                    v-if="controller.confirmRedeemModal != null">
        </confirm-redeem-modal>
        <draw-delivery-modal
                    :modalId="drawDeliveryId"
                    :controller="controller.drawDeliveryModal"
                    v-if="controller.drawDeliveryModal != null">
        </draw-delivery-modal>
        <serial-modal
                    :modalId="serialId"
                    :controller="controller.serialModal"
                    v-if="controller.serialModal != null">
        </serial-modal>
        <redeem-success-modal
                    :modalId="redeemSuccessId"
                    :controller="controller.redeemSuccessModal"
                    v-if="controller.redeemSuccessModal != null">
        </redeem-success-modal>
    </div>
</template>
<script>
import AlertModal from "./AlertModal.vue";
import ConfirmModal from "./ConfirmModal.vue";
import ErrorModal from "./ErrorModal.vue";
import LoadingModal from "./LoadingModal.vue";
import NoInternetModal from "./NoInternetModal.vue";
import SuccessModal from "./SuccessModal.vue";
import TermsModal from "./TermsModal.vue";
import CopySuccessToast from "./CopySuccessToast.vue";
//redeem
import ConfirmRedeemModal from "@/components/RedeemModal/Component/ConfirmRedeem/ConfirmRedeemModal.vue";
import DrawDeliveryModal from "@/components/RedeemModal/Component/DrawDelivery/DrawDeliveryModal.vue";
import SerialModal from "@/components/RedeemModal/Component/Serial/SerialModal.vue";
import RedeemSuccessModal from "@/components/RedeemModal/Component/RedeemSuccess/RedeemSuccessModal.vue";
/**
 * @property {ModalController} controller (required) /components/Modal/Controller/ModalController.js
 */
export default {
    name: "ModalMaster",
    props: {
        // busModal: Object,
        controller: Object,
    },
    components: {
        AlertModal,
        ConfirmModal,
        ErrorModal,
        LoadingModal,
        NoInternetModal,
        SuccessModal,
        TermsModal,
        CopySuccessToast,
        //redeem
        ConfirmRedeemModal,
        DrawDeliveryModal,
        SerialModal,
        RedeemSuccessModal
    },
    data: function() {
        return {
            randomNum: Math.floor(Math.random() * 100000) + '',
            alertId: '',
            errorId: '',
            confirmId: '',
            loadingId: '',
            noInternetId: '',
            successId: '',
            termsId: '',
            confirmRedeemId: '',
            drawDeliveryId: '',
            serialId: '',
            redeemSuccessId: '',
        };
    },
    created: function() {
        this.alertId = 'alert-modal-' + this.randomNum;
        this.errorId = 'error-modal-' + this.randomNum;
        this.confirmId = 'confirm-modal-' + this.randomNum;
        this.loadingId = 'loading-modal-' + this.randomNum;
        this.noInternetId = 'no-internet-modal-' + this.randomNum;
        this.successId = 'success-modal-' + this.randomNum;
        this.termsId = 'terms-modal-' + this.randomNum;
        //redeem
        this.confirmRedeemId = 'confirm-redeem-modal-' + this.randomNum;
        this.drawDeliveryId = 'draw-delivery-modal-' + this.randomNum;
        this.serialId = 'serial-modal-' + this.randomNum;
        this.redeemSuccessId = 'redeem-success-modal-' + this.randomNum;
    },
    mounted: function() {
        // this.alertModal.show();
    },
}
</script>
